// ROO-208: cute kawaii achievement-badge art, generated with the Gemini image
// API (see cleveroo-react/scripts/gen-badges.js) and bundled as WebP under
// src/assets/badges/<id>.webp — served from our own origin, no external URLs.
// The <id> matches the server ACHIEVEMENT_DEFS id, so a badge just needs a file
// dropped in that folder — no code change here.

/* eslint-disable @typescript-eslint/no-explicit-any */
const ctx = (require as any).context('../assets/badges', false, /\.webp$/);
const BADGES: Record<string, string> = {};
ctx.keys().forEach((k: string) => {
  const id = k.replace(/^\.\//, '').replace(/\.webp$/, '');
  BADGES[id] = ctx(k);
});
/* eslint-enable @typescript-eslint/no-explicit-any */

/** Bundled badge image for an achievement id, or null (caller falls back to the
 *  emoji glyph). */
export function badgeImage(id: string | null | undefined): string | null {
  return (id && BADGES[id]) || null;
}
